var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuffleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.50002L14 11L12.5 12.5M12.5 3.50002L14 5.00002L12.5 6.50002M2 11H4.66219C5.07372 11 5.4789 10.8984 5.84174 10.7042C6.20459 10.51 6.51389 10.2293 6.74219 9.88689L8 8.00002",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.00002H4.66219C5.07372 5.00002 5.4789 5.10162 5.84174 5.2958C6.20459 5.48998 6.51389 5.77073 6.74219 6.11314L9.25781 9.88689C9.48611 10.2293 9.79541 10.51 10.1583 10.7042C10.5211 10.8984 10.9263 11 11.3378 11H13M13 5.00002H11.3378C10.9263 5.00002 10.5211 5.10162 10.1583 5.2958C9.79541 5.48998 9.48611 5.77073 9.25781 6.11314L9 6.50002",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffleOutline);
export default __webpack_public_path__ + "static/media/shuffle-outline.8d14929e17c7232d415f4a206ee9945e.svg";
export { ForwardRef as ReactComponent };